/** Read a CSS custom property from :root (trimmed). Safe for SSR-less SPAs. */
export function readCssVar(name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

/** Scheduler / calendar appointment type colors — tied to platform tokens. */
export type SchedulerTypeKey = 'Vacation' | 'Sick' | 'Personal' | 'Other';

export function schedulerTypeColor(type: SchedulerTypeKey): string {
  const map: Record<SchedulerTypeKey, [string, string]> = {
    Vacation: ['--ops-status-running-fg', '#2563eb'],
    Sick: ['--ops-status-failed-fg', '#dc2626'],
    Personal: ['--ops-status-s3-fg', '#7c3aed'],
    Other: ['--ops-color-success', '#0f766e']
  };
  const [token, fallback] = map[type];
  return readCssVar(token, fallback);
}

export function buildSchedulerTypePalette(): Record<
  SchedulerTypeKey,
  { id: SchedulerTypeKey; color: string; text: SchedulerTypeKey }
> {
  return {
    Vacation: { id: 'Vacation', color: schedulerTypeColor('Vacation'), text: 'Vacation' },
    Sick: { id: 'Sick', color: schedulerTypeColor('Sick'), text: 'Sick' },
    Personal: { id: 'Personal', color: schedulerTypeColor('Personal'), text: 'Personal' },
    Other: { id: 'Other', color: schedulerTypeColor('Other'), text: 'Other' }
  };
}
